import type { LibraryBook } from "./types";

const naturalCollator = new Intl.Collator(["en", "ja"], {
  numeric: true,
  sensitivity: "base"
});

export interface LibrarySeriesGroup {
  id: string;
  title: string;
  books: LibraryBook[];
}

export function sortLibraryBooks(books: LibraryBook[]): LibraryBook[] {
  return [...books].sort((left, right) => {
    const seriesOrder = naturalCollator.compare(left.seriesTitle, right.seriesTitle);
    if (seriesOrder !== 0) return seriesOrder;

    const volumeOrder = naturalCollator.compare(left.title, right.title);
    if (volumeOrder !== 0) return volumeOrder;

    return left.createdAt.localeCompare(right.createdAt);
  });
}

export function groupLibraryBooks(books: LibraryBook[]): LibrarySeriesGroup[] {
  const groups = new Map<string, LibrarySeriesGroup>();

  for (const book of sortLibraryBooks(books)) {
    const group = groups.get(book.seriesId);
    if (group) {
      group.books.push(book);
    } else {
      groups.set(book.seriesId, { id: book.seriesId, title: book.seriesTitle, books: [book] });
    }
  }

  return [...groups.values()].sort((left, right) => naturalCollator.compare(left.title, right.title));
}

export function seriesCoverBooks(books: LibraryBook[], limit = 9): LibraryBook[] {
  const sorted = sortLibraryBooks(books);
  if (limit <= 0) return [];
  if (sorted.length <= limit) return sorted;
  if (limit === 1) return [sorted[0]];

  return Array.from({ length: limit }, (_, index) => {
    const sourceIndex = Math.round(index * (sorted.length - 1) / (limit - 1));
    return sorted[sourceIndex];
  });
}
